import { Grid, styled } from '../../../../base';

export const FlexGrid = styled(Grid)({
    display: 'flex',
    alignItems: 'center',
});

export const ScoreDot = styled('span')<{ color: string }>(
    ({ color, theme }) => ({
        display: 'inline-block',
        width: theme.spacing(1),
        height: theme.spacing(1),
        borderRadius: '50%',
        backgroundColor: color,
        marginInlineEnd: theme.spacing(1),
    })
);
